export const createLoadingSelector = actions => state => {
  return actions.filter(action => state.loading[action] === true).length;
};
